import type { AttachmentViewProps } from './registry'
import { toDocumentCards } from './document-attachment'

// 公文卡片（#1620）：主旨、機關、日期。有 onOpen 才可以點，
// 沒有就只是一張看得到的卡片。

export function DocumentCards({ content, onOpen }: AttachmentViewProps) {
  const cards = toDocumentCards(content)
  if (cards.length === 0) return null
  return (
    <ul className="doc-cards" aria-label="查到的文件">
      {cards.map((card) => {
        const body = (
          <>
            <span className="doc-card-subject">{card.subject || '（未填主旨）'}</span>
            <span className="doc-card-meta">
              {[card.bureau, card.issueDate].filter(Boolean).join('・') || '—'}
            </span>
          </>
        )
        return (
          <li key={card.documentId} className="doc-card">
            {onOpen ? (
              <button type="button" className="doc-card-open" onClick={() => onOpen(card.documentId)}>
                {body}
              </button>
            ) : (
              <div className="doc-card-static">{body}</div>
            )}
          </li>
        )
      })}
    </ul>
  )
}
